var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fixed inset-0 overflow-y-auto scrolling-touch z-90" },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full min-h-full flex items-center justify-center p-ogs",
        },
        [
          _c("div", {
            staticClass: "fixed inset-0 bg-black opacity-70 z-10",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "relative w-full max-w-lg px-6 md:px-12 bg-cream z-20",
              class: { "py-6 md:py-15": !_vm.snug, "py-6 md:py-8": _vm.snug },
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "absolute top-0 right-0 flex items-center justify-center h-10 w-10 md:h-15 md:w-15 link",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "w-4 h-4 md:w-5 md:h-5" },
                    [_c("IconCross")],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }